import BaseService from "services/BaseService";
import _ from "lodash";

class WorkSpaceService extends BaseService {
    list = async () => {
        var data = await this._api.post("master/workspace/list",);
        return data;
    }

  



}
export default WorkSpaceService;
